<template>
  <div class="result-box h-full w-full">
    <div class="parameter mt-6 mb-6 w-full text-center">
      <div v-if="iconHTML" class="w-20 mx-auto">
        <span v-html="iconHTML" class="icon"></span>
      </div>
      <p v-else class="text-center">
        <md-icon class="icon">{{ icon }}</md-icon>
      </p>
      <p class="result-txt text-center mt-4 w-20 mx-auto">{{ resultTxt }}</p>
    </div>
    <div class="result-box__info">
      <p class="title text-center">{{ title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["icon", "iconHTML", "resultTxt", "title"]
};
</script>

<style lang="scss" scoped>
.result-box {
  @apply p-2;
  @apply flex flex-col items-center;
  @apply bg-white;

  aspect-ratio: 1/1;

  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12),
    0px 6px 10px rgba(0, 0, 0, 0.14);
  border-radius: 4px;

  .result-txt,
  .icon {
    color: currentColor;
  }

  .icon {
    font-size: 2rem !important;
  }

  .result-txt {
    @apply mt-2;
    @apply text-lg font-medium;
    @apply leading-normal;
  }

  .title {
    font-weight: 500;
    font-size: 1rem;
    @apply text-gray-800 font-medium;
  }
}
</style>
